import CustomElement from "./CustomElement";

export default class ImagesPop extends CustomElement {
	constructor() {
		super();

		this.container = this.querySelector('.images-pop');

		if (!this.container) return;

		this.data = this.container.dataset;
		this.limit = parseInt(this.data.limit) || 5;
		this.images = [...this.querySelectorAll('img')];

		this.init();

	}

	init() {

		// Nothing to place, and nothing to clone from
		if (!this.images.length) return;

		//  Duplicate some if not enough images
		if (this.images.length < this.limit) {
			let remainder = this.limit - this.images.length;
			for (let i = 0; i < remainder; i++) {
				const randI = Math.floor(Math.random() * this.images.length);
				const img = this.images[randI].cloneNode();

				this.container.append(img);
				this.images.push(img);
			}
		}

		let rotations;
		let positions;

		switch (this.limit) {
			case 6:
				rotations = [
					40, -40, -60, 60, -40, 20
				]
				positions = [
					{ x: -24, y: -6 },
					{ x: -24, y: -27 },
					{ x: -6, y: -37 },
					{ x: 15, y: -31 },
					{ x: 23, y: -15 },
					{ x: 26, y: -1 }

				]
				break;

			default:
				rotations = [
					-20, -40, 60, 40, 20
				]
				positions = [
					{ x: -40, y: 28 },
					{ x: -41, y: -18 },
					{ x: 10, y: -30 },
					{ x: 40, y: 0 },
					{ x: 40, y: 33 }
				]
				break;
		}


		for (let i = 0; i < this.images.length; i++) {

			const position = positions[i];

			// More images than layout slots, leave the extras where they are
			if (!position) continue;

			this.images[i].style.setProperty('--x', `${position.x}%`);
			this.images[i].style.setProperty('--y', `${position.y}%`);
			this.images[i].style.setProperty('--rotation', `${rotations[i] ?? 0}deg`);

		}

	}
}
